import axios from "axios";
const httpUrl = 'http://aneesoft.cn/api/'

const uiwuGet = async (e)=>{
    console.log(e)
    return new Promise((resolve,reject)=>{
        axios.get(httpUrl + e.url,{
            params:{
                ...e.data
            }
        })
        .then((res)=>{
            if(res.status === 200){
                resolve(res.data)
            }
        })
        .catch((err)=>{
            reject(err)
        })
    })
   
}
export default{
    uiwuGet
}